<template>
    <div class="connected-labor-wrapper">
        <div class="sel-radio">
            <div :class="{ on: isSelected }" @click="radioSelect"></div>
            {{ connectedLaborTip }}
        </div>
        <div class="form-selected-content" v-show="isSelected">
            <Select
                class="form-type-select"
                :config="{ initLabel: data.name || '' }"
                :initValue="initFormId"
                :topOrBottom="86"
                :options="fromTypeOption"
                @menuClick="formSelected"
            >
                <Search :placeholder="formSelectedLabel" @searchChange="searchChange" @inputChange="searchChange" class="form-search" />
            </Select>
        </div>
    </div>
</template>

<script>
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";

import { debounce } from "@/views/zhiji/js/common/util.js";

export default {
    name: "ConnectedToLabor",
    props: ["data"],
    components: {
        Select,
        Search
    },
    computed: {
        isSelected() {
            return this.data && this.data.updateState != "delete";
        },
        initFormId() {
            return (
                (this.data.formId && {
                    formId: this.data.formId,
                    tagIds: this.data.tagIds
                }) ||
                "def"
            );
        },
        connectedLaborTip() {
            return this.$t("zhiji.answer.transLaborTip");
        },
        formSelectedLabel() {
            return this.$t("zhiji.answer.laborSearchLabel");
        },
        fromTypeOption() {
            let formTypeOption = [...this.getStorePorp("laborLinkDatas")];

            // 添加默认状态
            formTypeOption.unshift({
                label: this.$t("zhiji.answer.laborSearchLabel"),
                value: "def"
            });
            return formTypeOption;
        }
    },
    mounted() {
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchByFormName(searchField);
        }, 500);
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        searchByFormName(data) {
            this.$store.dispatch("zhiji/getLobarListData", {
                page: 1,
                size: 10,
                status: 1, // 只关联正常状态的表单
                keyword: data.value
            });
        },
        formSelected(data) {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateOption",
                option: {
                    name: data.label,
                    uId: this.data.uId,
                    tagIds: data.value.tagIds,
                    formId: data.value.formId + ""
                }
            });
        },
        radioSelect() {
            !this.isSelected ? this.addLaborHandle() : this.deleteLaborHandle();
        },
        addLaborHandle() {
            this.getFormListData();
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "addOption",
                option: {
                    itemType: "labor"
                }
            });
        },
        deleteLaborHandle() {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "deleteOption",
                option: this.data
            });
        },
        getFormListData() {
            this.$store.dispatch("zhiji/getLobarListData", {
                page: 1,
                size: 10,
                status: 1, // 只关联正常状态的表单
                keyword: ""
            });
        },
        searchChange(data) {
            this.searchHanlder(data);
        }
    }
};
</script>

<style lang="less" scoped>
.connected-labor-wrapper {
    margin-top: 20px;
    margin-bottom: 30px;
    .sel-radio {
        & > div {
            position: relative;
            top: 2px;
            display: inline-block;
            margin-right: 2px;
            width: 18px;
            height: 19px;
            background: url("@{zhijiStaticImagePath}class-spr.png");
            background-position: -275px 0;
            vertical-align: text-bottom;
            cursor: pointer;
        }

        .on {
            background-position: -275px -20px;
        }
    }
    .form-selected-content {
        width: 340px;
        margin-top: 5px;
        .form-type-select {
            width: 100%;
            color: #9b9ba3;
            background: #fff;
            .form-search {
                width: 100%;
                position: absolute;
                left: 0;
                top: 42px;
                background: #fff;
                z-index: 1;
            }
            .search-wrapper {
                padding: 7px 5px;
            }
        }
    }
}
</style>
